const React = require('react');
const ReactDOM = require('react-dom');
const PropTypes = require('prop-types');
const {connect} = require('react-redux');

const {withReq} = require('app/www/components/contexts/Req');
const {withI18n} = require('app/www/components/contexts/I18n');

const _intersection = require('lodash/intersection');

const Global = require('app/www/components/blocks/Global/Global');
const Metrika = require('app/www/libs/client/metrika');
const Ua = require('app/www/components/blocks/Ua/Ua');

const ProgramEpisodes_List = require('app/www/components/blocks/ProgramEpisodes/_List/ProgramEpisodes_List');
const ProgramEpisodes_Modal = require('app/www/components/blocks/ProgramEpisodes/_Modal/ProgramEpisodes_Modal');

const CURRENT_YEAR = new Date().getFullYear();

class ProgramEpisodes extends React.PureComponent {
    constructor(props) {
        super(props);

        const {episodes, hasComplexHeader, programType} = props;
        this._episodesBySeason = null;
        let selectedSeason = null;

        this._showEpisodes = episodes && episodes.length !== 0 &&
            (Ua.isRobot || Global.isRussia && !Ua.isOldOpera && !Ua.isOldIE);

        if (hasComplexHeader &&
            this._showEpisodes &&
            !Ua.isRobot &&
            programType.isSerial &&
            episodes.every(e => typeof e.seasonNumber === 'number') &&
            episodes.some(e => e.seasonNumber !== episodes[0].seasonNumber)
        ) {
            selectedSeason = episodes[0].seasonNumber;
            this._episodesBySeason = episodes.reduce((obj, episode) => {
                if (!obj[episode.seasonNumber]) {
                    obj[episode.seasonNumber] = [];
                }

                obj[episode.seasonNumber].push(episode);

                return obj;
            }, {});
        }

        this.state = {
            selectedSeason,
        };

        this._getEpisodeTitles = this._getEpisodeTitles.bind(this);
        this._onSelectEpisode = this._onSelectEpisode.bind(this);
        this._onTabChange = this._onTabChange.bind(this);
    }

    componentDidMount() {
        if (this._showEpisodes) {
            this._modalContainer = document.createElement('div');
            document.body.appendChild(this._modalContainer);
        }
    }

    componentWillUnmount() {
        if (this._modalContainer) {
            document.body.removeChild(this._modalContainer);
        }
    }

    render() {
        const {selectedSeason} = this.state;
        const {
            episodes,
            showModal,
            canonicalUrl,
            hasComplexHeader,
            selectedEpisode,
            isLayoutColumnsLarge,
            programId,
            channelsId,
            programTitle,
            programType,
            programDuration,
            userSubscription,
            channelsSubscription,
        } = this.props;

        if (!this._showEpisodes) {
            return null;
        }

        const hasSeasons = Boolean(this._episodesBySeason);
        const hasMoreThanOneEpisode = episodes.length > 1;

        const props = {
            episodes,
            programId,
            hasSeasons,
            programTitle,
            selectedSeason,
            selectedEpisode,
            hasComplexHeader,
            hasMoreThanOneEpisode,
            getEpisodeTitles: this._getEpisodeTitles,
            onSelectEpisode: this._onSelectEpisode,
            onTabChange: this._onTabChange,
        };

        const extraProps = {
            canonicalUrl,
            programType,
            programDuration,
            isLayoutColumnsLarge,
        };

        const isAvailableToUserEpisodes = !_intersection(channelsSubscription, channelsId)[0] || Boolean(userSubscription);

        if (!isAvailableToUserEpisodes) {
            return null;
        }

        if (Ua.isRobot) {
            return (
                <ProgramEpisodes_List {...props} {...extraProps} />
            );
        }

        if (hasSeasons) {
            props.episodes = this._episodesBySeason[selectedSeason];
            props.tabsItems = this._tabsItems;
        } else {
            props.episodes = episodes;
        }

        if (Ua.displayWidth && !Ua.isLayoutColumnsSmall) {
            return (
                <ProgramEpisodes_List {...props} {...extraProps} />
            );
        } else if (selectedEpisode || showModal) {
            if (!selectedEpisode) {
                props.firstEpisode = episodes[0];
            }

            return ReactDOM.createPortal(
                <ProgramEpisodes_Modal {...props} />,
                this._modalContainer
            );
        }

        return null;
    }

    /**
     * @private
     */
    get _tabsItems() {
        if (typeof this._tabsItemsValue === 'undefined') {
            const {i18n} = this.props;
            this._tabsItemsValue = Object.keys(this._episodesBySeason).map(key => ({
                id: Number(key),
                text: i18n.get('program-episodes.season-tab-title', {number: key}),
            }));
        }

        return this._tabsItemsValue;
    }

    /**
     * Returns title and subtitle for episode
     * @param {Object} episode
     * @private
     * @returns {Object} title, subtitle
     */
    _getEpisodeTitles(episode) {
        const moment = this.props.req.lib('moment');

        let date;
        let title;
        let subtitle;

        if (episode.date) {
            date = new Date(episode.date);
            const format = date.getFullYear() === CURRENT_YEAR ? 'D MMMM' : 'D MMMM YYYY';
            title = moment.getFormattedDate(format, date);
        }

        if (this.props.programTitle !== episode.title) {
            subtitle = episode.title;
        } else if (episode.date && this._haveDuplicateDates) {
            subtitle = moment.getFormattedDate('HH:mm', date);
        }

        return {title, subtitle};
    }

    /**
     * @private
     */
    get _haveDuplicateDates() {
        if (typeof this._haveDuplicateDatesValue === 'undefined') {
            const {episodes} = this.props;

            const uniqueDates = episodes.reduce((dates, episode) => {
                const date = new Date(episode.date);
                const dateMonthString = `${date.getDate()}_${date.getMonth()}`;

                if (dates.indexOf(dateMonthString) === -1) {
                    dates.push(dateMonthString);
                }

                return dates;
            }, []);

            this._haveDuplicateDatesValue = uniqueDates.length !== episodes.length;
        }

        return this._haveDuplicateDatesValue;
    }

    /**
     * @param {Object} episode
     * @private
     */
    _onSelectEpisode(episode) {
        const {onSelectEpisode} = this.props;

        if (!episode) {
            return () => onSelectEpisode(null);
        }

        return (evt) => {
            const {
                i18n,
                episodes,
                programType,
                programTitle,
                programId,
                hasComplexHeader,
                selectedEpisode,
            } = this.props;
            const {selectedSeason} = this.state;

            let currentEpisodes;

            if (this._episodesBySeason) {
                currentEpisodes = this._episodesBySeason[selectedSeason];
            } else {
                currentEpisodes = episodes;
            }

            const position = currentEpisodes.indexOf(episode) + 1;
            const target = hasComplexHeader && selectedEpisode ? 'dark_carousel' : 'carousel';

            evt.preventDefault();
            onSelectEpisode(episode);

            Metrika.trackParams('VOD', {
                param: 'video_click',
                programTitle,
                programType: programType.alias,
                programId,
                target,
                position,
                tab: selectedSeason && i18n.get('program-episodes.season-tab-title', {number: selectedSeason}),
            });
        };
    }

    /**
     * @private
     */
    _onTabChange(tabId) {
        const {
            i18n,
            programType,
            programTitle,
            programId,
        } = this.props;

        this.setState({selectedSeason: tabId});

        Metrika.trackParams('VOD', {
            param: 'tab_click',
            programTitle,
            programType: programType.alias,
            programId,
            tab: i18n.get('program-episodes.season-tab-title', {number: tabId}),
        });
    }
}

function mapStateToProps(state) {
    return {
        userSubscription: state.userSubscription,
    };
}

ProgramEpisodes.propTypes = {
    showModal: PropTypes.bool,
    hasComplexHeader: PropTypes.bool,
    isLayoutColumnsLarge: PropTypes.bool,
    canonicalUrl: PropTypes.string.isRequired,
    programId: PropTypes.number.isRequired,
    programTitle: PropTypes.string.isRequired,
    programType: PropTypes.object.isRequired,
    programDuration: PropTypes.number,
    selectedEpisode: PropTypes.object,
    onSelectEpisode: PropTypes.func,
    episodes: PropTypes.arrayOf(
        PropTypes.shape({
            date: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            duration: PropTypes.number,
            embedUrl: PropTypes.string.isRequired,
            contentId: PropTypes.string.isRequired,
            thumbnail: PropTypes.string.isRequired,
            uploadDate: PropTypes.number.isRequired,
            description: PropTypes.string.isRequired,
            seasonNumber: PropTypes.number,
            episodeNumber: PropTypes.number,
            isFamilyFriendly: PropTypes.bool.isRequired,
        })
    ),
};

module.exports = connect(
    mapStateToProps
)(
    withReq(withI18n(
        ProgramEpisodes
    ))
);
